// extracted by mini-css-extract-plugin
export default {"backgroundImg":"JP_CommitmentStrategy_backgroundImg__CEuvs","boxContent":"JP_CommitmentStrategy_boxContent__7QsTb","contentImage":"JP_CommitmentStrategy_contentImage__r3k4c"};